import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface SearchBoxProps {
  defaultValue?: string;
  size?: 'sm' | 'lg';
  placeholder?: string;
  autoFocus?: boolean;
}

export default function SearchBox({
  defaultValue = '',
  size = 'sm',
  placeholder = '搜索热点资讯、人物或话题…',
  autoFocus = false,
}: SearchBoxProps) {
  const [value, setValue] = useState(defaultValue);
  const navigate = useNavigate();

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    const kw = value.trim();
    if (!kw) return;
    navigate(`/search?q=${encodeURIComponent(kw)}`);
  };

  const isLarge = size === 'lg';

  return (
    <form
      onSubmit={handleSubmit}
      role="search"
      className={`flex items-center gap-2 rounded-md border border-background-300 bg-background-100 ${
        isLarge ? 'px-4 py-3' : 'px-3 py-2'
      }`}
    >
      <div
        className={`flex items-center justify-center text-foreground-400 ${
          isLarge ? 'w-6 h-6 text-xl' : 'w-5 h-5 text-base'
        }`}
      >
        <i className="ri-search-line"></i>
      </div>
      <input
        type="search"
        name="keyword"
        value={value}
        autoFocus={autoFocus}
        onChange={(event) => setValue(event.target.value)}
        placeholder={placeholder}
        className={`flex-1 bg-transparent outline-none text-foreground-900 placeholder:text-foreground-400 font-body ${
          isLarge ? 'text-base' : 'text-sm'
        }`}
      />
      <button
        type="submit"
        className={`shrink-0 whitespace-nowrap rounded-md bg-primary-500 font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950 ${
          isLarge ? 'px-6 py-2 text-sm' : 'px-3 py-1.5 text-xs'
        }`}
      >
        搜索
      </button>
    </form>
  );
}